import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ClosureSettingsIndex from './Index.vue';
import ClosureStatistics from './Statistics.vue';
import ClosurePanel from './Panel.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/closures'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'closure_settings_index',
          component: ClosureSettingsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'statistics',
          name: 'closure_statistics_index',
          component: ClosureStatistics,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'panel',
          name: 'closure_panel_index',
          component: ClosurePanel,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
